import { gql } from "@apollo/client";
import { QueryItemOnProfileFragment } from "lib/types/graphql";

export const queryItemOnProfileGqlFragment = gql`
  fragment QueryItemOnProfile on queries {
    id
    name
    created_at
    tags

    query_favorite_count_all {
      favorite_count
    }
  }
`;

export interface QueryOnProfileType {
  id: number;
  name: string;
  created_at: string;
  tags: string[];
  favoriteCount: number;
}

export function toQueryOnProfileType(
  query: QueryItemOnProfileFragment
): QueryOnProfileType {
  return {
    id: query.id,
    name: query.name ?? "",
    created_at: query.created_at,
    tags: query.tags ?? [],
    favoriteCount: query.query_favorite_count_all?.favorite_count ?? 0,
  };
}
